import React from 'react'
import { Table } from 'antd'
import PropTypes from 'prop-types'
import { ReviewTableColumns } from '../constants'

const ReviewTable = ({ tableData }) => {
  return (
    <div className='z-40'>
      <Table
        columns={ReviewTableColumns}
        dataSource={tableData.data}
        loading={tableData.loading}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          current: 1
        }}
      />
    </div>
  )
}

ReviewTable.propTypes = {
  tableData: PropTypes.shape({
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool
  }).isRequired
}

// Default props with loading set to true
ReviewTable.defaultProps = {
  tableData: { data: [], loading: true }
}

export default ReviewTable
